const ECN_TRADE_SYMBOL_SUMMARY = 'ecn-trade-symbol-summary';
const ECN_TRADE_MMID_SUMMARY = 'ecn-trade-mmid-summary';

const ECN_ORDER_SYMBOL_SUMMARY = 'ecn-order-symbol-summary';
const ECN_ORDER_MMID_SUMMARY = 'ecn-order-mmid-summary';

const ECN_OPEN_ORDER_SYMBOL_SUMMARY = 'ecn-open-order-symbol-summary';
const ECN_OPEN_ORDER_MMID_SUMMARY = 'ecn-open-order-mmid-summary';

const ECN_UNENTITLED_SYMBOLS_SUMMARY = 'ecn-unentitled-symbol-order-summary';

const ECN_ORDER_TRADE_RATIO_SUMMARY = 'ecn-order-trade-ratio-summary';

/// IDQS /////////

const IDQS_DAY_TRADE_SYMBOL_SUMMARY = 'idqs-day-trade-symbol-summary';
const IDQS_DAY_TRADE_MMID_SUMMARY = 'idqs-day-trade-mmid-summary';

const IDQS_DAY_ORDER_SYMBOL_SUMMARY = 'idqs-day-order-symbol-summary';
const IDQS_DAY_ORDER_MMID_SUMMARY = 'idqs-day-order-mmid-summary';

const IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY = 'idqs-day-open-order-symbol-summary';
const IDQS_DAY_OPEN_ORDER_MMID_SUMMARY = 'idqs-day-open-order-mmid-summary';

const IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY = 'idqs-day-unentitled-symbol-order-summary';

const IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY = 'idqs-day-order-trade-ratio-summary';

/// IDQS NIGHT/////////

const IDQS_NIGHT_TRADE_SYMBOL_SUMMARY = 'idqs-night-trade-symbol-summary';
const IDQS_NIGHT_TRADE_MMID_SUMMARY = 'idqs-night-trade-mmid-summary';

const IDQS_NIGHT_ORDER_SYMBOL_SUMMARY = 'idqs-night-order-symbol-summary';
const IDQS_NIGHT_ORDER_MMID_SUMMARY = 'idqs-night-order-mmid-summary';

const IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY = 'idqs-night-open-order-symbol-summary';
const IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY = 'idqs-night-open-order-mmid-summary';

const IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY = 'idqs-night-unentitled-symbol-order-summary';

const IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY = 'idqs-night-order-trade-ratio-summary';

/// IDQS NMS/////////

const IDQS_NMS_TRADE_SYMBOL_SUMMARY = 'idqs-nms-trade-symbol-summary';
const IDQS_NMS_TRADE_MMID_SUMMARY = 'idqs-nms-trade-mmid-summary';

const IDQS_NMS_ORDER_SYMBOL_SUMMARY = 'idqs-nms-order-symbol-summary';
const IDQS_NMS_ORDER_MMID_SUMMARY = 'idqs-nms-order-mmid-summary';

const IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY = 'idqs-nms-open-order-symbol-summary';
const IDQS_NMS_OPEN_ORDER_MMID_SUMMARY = 'idqs-nms-open-order-mmid-summary';

const IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY = 'idqs-nms-unentitled-symbol-order-summary';

const IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY = 'idqs-nms-order-trade-ratio-summary';

/// //////////ATS ////////////////

const ATS_TRADE_SYMBOL_SUMMARY = 'ats-trade-symbol-summary';
const ATS_TRADE_MMID_SUMMARY = 'ats-trade-mmid-summary';

const ATS_QUOTE_SYMBOL_SUMMARY = 'ats-quote-symbol-summary';
const ATS_QUOTE_FREQ_SYMBOL_SUMMARY = 'ats-quote-symbol-freq-summary';
const ATS_QUOTE_MMID_SUMMARY = 'ats-quote-mmid-summary';
const ATS_QUOTE_FREQ_MMID_SUMMARY = 'ats-quote-mmid-freq-summary';

/// TDDS ////
const TDDS_NOTIONAL_RATIO_SUMMARY = 'tdds-notional-ratio-summary';
const TDDS_SHARE_RATIO_SUMMARY = 'tdds-share-ratio-summary';
const TDDS_TRADE_RATIO_SUMMARY = 'tdds-trade-ratio-summary';

// RISK

const ECN_RISK_SUMMARY = 'ecn-risk-summary';
const IDQS_RISK_SUMMARY = 'idqs-risk-summary';
const UNMATCHED_TRADES = 'unmatched-trades';
const UNMATCHED_OTHER_TRADES = 'unmatched-other-trades';
const LOCK_CROSS_QUOTES = 'lock-cross-risk-summary';
const L1_TRADES = 'l1-trades-summary';
const TRF_TRADES = 'trf-trades-summary';

/// //////COLUMNS

const TRADES_COLUMN = { dataField: 'tradeCount', caption: 'Trades', type: 'number' };
const ORDERS_COLUMN = { dataField: 'orderCount', caption: 'Orders', type: 'number' };
const OPEN_ORDERS_COLUMN = { dataField: 'openOrderCount', caption: 'Orders', type: 'number' };
const ORDERS_TRADE_RATIO_COLUMN = { dataField: 'ratio', caption: 'Ratio', type: 'number' };

const QUOTES_COLUMN = { dataField: 'quoteCount', caption: 'Quotes', type: 'number' };
const VOLUME_COLUMN = { dataField: 'volume', caption: 'Volume', type: 'number' };
const NOTIONAL_COLUMN = { dataField: 'notional', caption: 'Notional', type: 'notional' };

const SYMBOL_COLUMN = { dataField: 'symbol', caption: 'Symbol' };
const MPID_COLUMN = { dataField: 'mpid', caption: 'MPID' };
const SENDER_MPID_COLUMN = { dataField: 'senderMpid', caption: 'Sender MPID' };
const RECEIVER_MPID_COLUMN = { dataField: 'receiverMpid', caption: 'Receiver MPID' };
const MMID_COLUMN = { dataField: 'mmid', caption: 'MPID' };

// TDDS SPECIFIC

// TDDS TRADE RATIO
const OTCXN_TRADE_COLUMN = { dataField: 'otcxnTradeCount', caption: 'OTCX/N', type: 'number', totalField: 'totalOtcxnTradeCount' };
const OTCXN_TRADE_RATIO_COLUMN = { dataField: 'otcxnTradeCountRatio', caption: 'OTCX/N %', type: 'percent' };
const ATS_TRADE_COLUMN = { dataField: 'atsTradeCount', caption: 'Link ATS', type: 'number', totalField: 'totalAtsTradeCount' };
const ATS_TRADE_RATIO_COLUMN = { dataField: 'atsTradeCountRatio', caption: 'Link ATS %', type: 'percent' };
const TDDS_TRADE_COLUMN = { dataField: 'tddsTradeCount', caption: 'TDDS', type: 'number', totalField: 'totalTddsTradeCount' };

// TDDS SHARE RATIO

const OTCXN_SHARE_COLUMN = { dataField: 'otcxnTradeVolume', caption: 'OTCX/N', type: 'number', totalField: 'totalOtcxnTradeVolume' };
const OTCXN_SHARE_RATIO_COLUMN = { dataField: 'otcxnTradeVolumeRatio', caption: 'OTCX/N %', type: 'percent' };
const ATS_SHARE_COLUMN = { dataField: 'atsTradeVolume', caption: 'Link ATS', type: 'number', totalField: 'totalAtsTradeVolume' };
const ATS_SHARE_RATIO_COLUMN = { dataField: 'atsTradeVolumeRatio', caption: 'Link ATS %', type: 'percent' };
const TDDS_SHARE_COLUMN = { dataField: 'tddsTradeVolume', caption: 'TDDS', type: 'number', totalField: 'totalTddsTradeVolume' };

// TDDS NOTIONAL RATIO

const OTCXN_NOTIONAL_COLUMN = { dataField: 'otcxnTradeNotional', caption: 'OTCX/N', type: 'notional', totalField: 'totalOtcxnTradeNotional' };
const OTCXN_NOTIONAL_RATIO_COLUMN = { dataField: 'otcxnTradeNotionalRatio', caption: 'OTCX/N %', type: 'percent' };
const ATS_NOTIONAL_COLUMN = { dataField: 'atsTradeNotional', caption: 'Link ATS', type: 'notional', totalField: 'totalAtsTradeNotional' };
const ATS_NOTIONAL_RATIO_COLUMN = { dataField: 'atsTradeNotionalRatio', caption: 'Link ATS %', type: 'percent' };
const TDDS_NOTIONAL_COLUMN = { dataField: 'tddsTradeNotional', caption: 'TDDS', type: 'notional', totalField: 'totalTddsTradeNotional' };

// RISK tab
const EXEC_TINE_COLUMN = { dataField: 'execTime', caption: 'Execution Time' };
const CONTRA_BROKER_COLUMN = { dataField: 'contraBroker', caption: 'Contra MPID' };
const SECURITY_COLUMN = { dataField: 'security', caption: 'Symbol' };
const SIDE_COLUMN = { dataField: 'side', caption: 'Side', type: 'side' };
const CL_ORID_COLUMN = { dataField: 'clordid', caption: 'Cl Ord ID' };
const EXEC_PRICE_COLUMN = { dataField: 'execPrice', caption: 'Exec Price' };
const EXEC_QTY_COLUMN = { dataField: 'execQty', caption: 'Exec Qty', type: 'number' };
const TRADE_OG_QTY_COLUMN = { dataField: 'originalQuantity', caption: 'Qty', type: 'number' };
const TRADE_STATE_COLUMN = { dataField: 'tradeState', caption: 'State' };
const CLIENT_EXEC_ID_COLUMN = { dataField: 'execId', caption: 'Client Exec ID' };
const SYSTEM_INTERNAL_ID_COLUMN = { dataField: 'internalId', caption: 'Internal Exec ID' };
const SYSTEM_ACK_COLUMN = { dataField: 'systemAcked', caption: 'Resolved', type: 'boolean' };
const DURATION_COLUMN = { dataField: 'duration', caption: 'Duration (seconds)', type: 'number' };
const TRADE_ID_COLUMN = { dataField: 'tradeId', caption: 'Trade ID', type: 'right-align' };
const USER_ACK_COLUMN = { dataField: 'userAcked', caption: 'User Acknowledged', type: 'boolean' };
const TRADE_DATE_TIME_COLUMN = { dataField: 'tradeTime', caption: 'Trade Date', type: 'dateTime' };

const PRICE_COLUMN = { dataField: 'price', caption: 'Price', type: 'spPrice' };
const INSIDE_PRICE_COLUMN = { dataField: 'inside', caption: 'Inside' };
const LOCK_CROSS_TIME_COLUMN = { dataField: 'lcTime', caption: 'L/C Time', type: 'time' };
const RESOLVED_ALERT_COLUMN = { dataField: 'resolved', caption: 'Resolved', type: 'boolean' };
const TRADE_TIME_COLUMN = { dataField: 'tradeTime', caption: 'Trade Time', type: 'time' };
const TRADE_CLOSE_TIME_COLUMN = { dataField: 'tradeCloseTime', caption: 'Trade Close Time', type: 'time' };
const TRADE_PRICE_COLUMN = { dataField: 'tradePrice', caption: 'Price', type: 'spPrice' };
const QUOTE_INSIDE_PRICE_COLUMN = { dataField: 'insidePrice', caption: 'PBBO Inside Price', type: 'spPrice' };

// TRF
const TRADE_EXEC_ID_COLUMN = { dataField: 'execId', caption: 'Trade ID' };
const NOTIONAL_VALUE_COLUMN = { dataField: 'notionalValue', caption: 'Notional', type: 'notional' };
const TRADE_DATE_COLUMN = { dataField: 'tradeDate', caption: 'Trade Date' };
const CUST_ORD_ID_COLUMN = { dataField: 'customerOrderId', caption: 'Cust Order ID ' };
const CONTRA_ORD_ID_COLUMN = { dataField: 'contraOrderId', caption: 'Contra Order ID ' };
const AVG_PRICE_COLUMN = { dataField: 'avgPx', caption: 'Price', type: 'spPrice' };
const CUM_QTY_COLUMN = { dataField: 'cumQty', caption: 'Qty', type: 'number' };
const TEXT_COLUMN = { dataField: 'text', caption: 'Text', width: '80px' };

const COLUMN_HEIGHT = 22;

const PAGE_TAB_ITEMS = [
  {
    path: '/risk-dashboard',
    title: 'Risk Monitoring'
  },
  {
    path: '/dashboard',
    title: 'Day Trading'
  },
  {
    path: '/overnight-dashboard',
    title: 'Overnight Trading'
  },
  {
    path: '/ats-tdds-dashboard',
    title: 'ATS / TDDS'
  },
  {
    path: '/history-risk-dashboard',
    title: 'Historical Risks'
  },
  {
    path: '/history-dashboard',
    title: 'Historical Day Trading'
  },
  {
    path: '/history-overnight-dashboard',
    title: 'Historical Overnight Trading'
  },
  {
    path: '/history-ats-tdds-dashboard',
    title: 'Historical ATS / TDDS'
  }
];

export {
  ECN_TRADE_SYMBOL_SUMMARY, ECN_TRADE_MMID_SUMMARY, ECN_ORDER_SYMBOL_SUMMARY, ECN_ORDER_MMID_SUMMARY,
  ECN_OPEN_ORDER_SYMBOL_SUMMARY, ECN_OPEN_ORDER_MMID_SUMMARY,
  ECN_UNENTITLED_SYMBOLS_SUMMARY, ECN_ORDER_TRADE_RATIO_SUMMARY,

  IDQS_DAY_TRADE_SYMBOL_SUMMARY, IDQS_DAY_TRADE_MMID_SUMMARY, IDQS_DAY_ORDER_SYMBOL_SUMMARY, IDQS_DAY_ORDER_MMID_SUMMARY,
  IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_DAY_OPEN_ORDER_MMID_SUMMARY, IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY, IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY,

  IDQS_NIGHT_TRADE_SYMBOL_SUMMARY, IDQS_NIGHT_TRADE_MMID_SUMMARY, IDQS_NIGHT_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_ORDER_MMID_SUMMARY,
  IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY, IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY,

  IDQS_NMS_TRADE_SYMBOL_SUMMARY, IDQS_NMS_TRADE_MMID_SUMMARY, IDQS_NMS_ORDER_SYMBOL_SUMMARY, IDQS_NMS_ORDER_MMID_SUMMARY,
  IDQS_NMS_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NMS_OPEN_ORDER_MMID_SUMMARY, IDQS_NMS_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NMS_ORDER_TRADE_RATIO_SUMMARY,

  ATS_TRADE_SYMBOL_SUMMARY, ATS_TRADE_MMID_SUMMARY, ATS_QUOTE_SYMBOL_SUMMARY, ATS_QUOTE_MMID_SUMMARY,
  ATS_QUOTE_FREQ_SYMBOL_SUMMARY, ATS_QUOTE_FREQ_MMID_SUMMARY,

  TDDS_NOTIONAL_RATIO_SUMMARY, TDDS_SHARE_RATIO_SUMMARY, TDDS_TRADE_RATIO_SUMMARY,

  ECN_RISK_SUMMARY, IDQS_RISK_SUMMARY, UNMATCHED_TRADES, UNMATCHED_OTHER_TRADES, LOCK_CROSS_QUOTES, L1_TRADES, TRF_TRADES,

  COLUMN_HEIGHT, PAGE_TAB_ITEMS,
  ORDERS_COLUMN, OPEN_ORDERS_COLUMN, TRADES_COLUMN, QUOTES_COLUMN, VOLUME_COLUMN, NOTIONAL_COLUMN, NOTIONAL_VALUE_COLUMN,
  SYMBOL_COLUMN, MMID_COLUMN, MPID_COLUMN, ORDERS_TRADE_RATIO_COLUMN,
  SENDER_MPID_COLUMN, RECEIVER_MPID_COLUMN, TRADE_TIME_COLUMN, TRADE_CLOSE_TIME_COLUMN,
  QUOTE_INSIDE_PRICE_COLUMN, TRADE_PRICE_COLUMN,
  TRADE_DATE_COLUMN, CUST_ORD_ID_COLUMN, CONTRA_ORD_ID_COLUMN, AVG_PRICE_COLUMN, CUM_QTY_COLUMN, TRADE_EXEC_ID_COLUMN, TEXT_COLUMN,
  OTCXN_TRADE_COLUMN, OTCXN_TRADE_RATIO_COLUMN, ATS_TRADE_COLUMN, ATS_TRADE_RATIO_COLUMN, TDDS_TRADE_COLUMN,
  OTCXN_SHARE_COLUMN, OTCXN_SHARE_RATIO_COLUMN, ATS_SHARE_COLUMN, ATS_SHARE_RATIO_COLUMN, TDDS_SHARE_COLUMN,
  OTCXN_NOTIONAL_COLUMN, OTCXN_NOTIONAL_RATIO_COLUMN, ATS_NOTIONAL_COLUMN, ATS_NOTIONAL_RATIO_COLUMN, TDDS_NOTIONAL_COLUMN,
  EXEC_TINE_COLUMN, CONTRA_BROKER_COLUMN, SECURITY_COLUMN, SIDE_COLUMN, CL_ORID_COLUMN, EXEC_PRICE_COLUMN, EXEC_QTY_COLUMN,
  SYSTEM_INTERNAL_ID_COLUMN, SYSTEM_ACK_COLUMN, CLIENT_EXEC_ID_COLUMN, DURATION_COLUMN, TRADE_ID_COLUMN, USER_ACK_COLUMN, TRADE_DATE_TIME_COLUMN,
  TRADE_OG_QTY_COLUMN, TRADE_STATE_COLUMN,
  PRICE_COLUMN, INSIDE_PRICE_COLUMN, LOCK_CROSS_TIME_COLUMN, RESOLVED_ALERT_COLUMN
};
